import { EExternalActionType } from "./externalAction.copy";

/**
 * Whose page an external-action link opens (DEV-3330, Jonas 2026-10-07): a
 * Rentmatch action looks like Rentmatch, everything else like Rentio. Only the
 * logo and the button color follow the brand; layout, texts and behavior are
 * the same page.
 */
export enum EExternalActionBrand {
  Rentio = "rentio",
  Rentmatch = "rentmatch",
}

/** A future Rentmatch action only adds a line here. */
const BRAND_BY_ACTION_TYPE: Partial<
  Record<EExternalActionType, EExternalActionBrand>
> = {
  [EExternalActionType.ApplicationNoInterest]: EExternalActionBrand.Rentmatch,
};

export const getExternalActionBrand = (
  actionType?: EExternalActionType,
): EExternalActionBrand =>
  (actionType && BRAND_BY_ACTION_TYPE[actionType]) ||
  EExternalActionBrand.Rentio;

/**
 * Rentmatch's button color: its own `--color-primary` token in the rentmatch
 * repo (src/tailwind.css), which every Rentmatch primary button uses. The
 * Rentio theme carries no Rentmatch color to read it from.
 */
export const RENTMATCH_PRIMARY_COLOR = "#1B1E38";

/**
 * The page's theme with the primary color swapped for Rentmatch's, so the
 * button keeps its own styling and only changes color. Every primary shade
 * maps to the one token, because Rentmatch has no shades of its own.
 */
export const withRentmatchPrimary = <
  TTheme extends { getColor: (hue: string, value?: string | number) => string },
>(
  theme: TTheme,
): TTheme => ({
  ...theme,
  getColor: (hue: string, value?: string | number) =>
    hue === "primary" ? RENTMATCH_PRIMARY_COLOR : theme.getColor(hue, value),
});
